function o(t) {
  return t ? Object.keys(t) : [];
}
function u(t, s) {
  return (t ?? []).reduce((e, n) => {
    const r = n[s];
    return e.set(r, n), e;
  }, /* @__PURE__ */ new Map());
}
function f(t, s) {
  return (t ?? []).reduce((e, n) => {
    const r = n[s], y = e[r];
    return y ? e[r] = [...y, n] : e[r] = [n], e;
  }, {});
}
export {
  f as a,
  u as c,
  o as g
};
